import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/family-planning/genetic-counseling-before-pregnancy/#webpage",
   "url": "https://www.futurefamilyai.com/family-planning/genetic-counseling-before-pregnancy/",
   "name": "Genetic Counseling Before Pregnancy | FutureFamilyAI",
   "description": "What a genetic counselor reviews, when to book, and how counseling helps you understand carrier results and options before pregnancy.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Family Planning & Carrier Screening",
     "item": "https://www.futurefamilyai.com/family-planning/carrier-screening/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Genetic Counseling Before Pregnancy",
     "item": "https://www.futurefamilyai.com/family-planning/genetic-counseling-before-pregnancy/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "What happens at a preconception genetic counseling appointment?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "A counselor reviews your history, explains testing options and results, and discusses next steps."
     }
    },
    {
     "@type": "Question",
     "name": "When should I see a genetic counselor?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Before pregnancy is ideal, especially after a positive carrier result or with a family history."
     }
    },
    {
     "@type": "Question",
     "name": "Is genetic counseling covered by insurance?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Often, when medically indicated. Check with your plan."
     }
    },
    {
     "@type": "Question",
     "name": "Can I do genetic counseling online?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Many counselors offer video visits."
     }
    },
    {
     "@type": "Question",
     "name": "Do both partners need to attend?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It helps, but it isn't required."
     }
    },
    {
     "@type": "Question",
     "name": "Will the counselor tell me what to do?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Counselors explain options; decisions are yours."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function FamilyPlanningGeneticCounselingBeforePregnancyPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/family-planning/carrier-screening">
                Family Planning &amp; Carrier Screening
              </Link>
              <span>›</span>
              <span>Genetic Counseling Before Pregnancy</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Genetic counseling before pregnancy is a visit with a genetics
                professional who reviews your personal and family history,
                explains carrier screening options and helps you understand what
                positive, negative or uncertain results mean.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Planning couples</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      ACOG recommends offering carrier screening for cystic
                      fibrosis and spinal muscular atrophy to everyone who is
                      considering pregnancy or is pregnant. (ACOG Committee
                      Opinion No. 691, 2017)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Book from inside the app · Bring organized results and
                      history · Video, phone or in-person options
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">FAMILY PLANNING GUIDE</span>
            <h1>Genetic Counseling Before Pregnancy — Expert Guidance</h1>
            <p className="ffh-answer speakable-content">
              Genetic counseling before pregnancy is a visit with a genetics
              professional who reviews your personal and family history,
              explains carrier screening options and helps you understand what
              positive, negative or uncertain results mean. It supports informed
              choices rather than predicting outcomes. FutureFamilyAI members
              can book consultations with genetics professionals to review
              results. Prepare for your appointment.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Couple meeting a genetic counselor by video before pregnancy"
              >
                <figcaption>
                  <b>Photo slot</b> · Genetic counselor (any gender, 40s) on a
                  video call seen from over a couple&apos;s shoulders on a
                  laptop, warm home setting. No on-screen text.
                  <br />
                  <b>Alt:</b> Couple meeting a genetic counselor by video before
                  pregnancy
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    ACOG recommends offering carrier screening for cystic
                    fibrosis and spinal muscular atrophy to everyone who is
                    considering pregnancy or is pregnant.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2017/03/carrier-screening-for-genetic-conditions">
                        ACOG Committee Opinion No. 691, 2017
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What happens in a session</h2>
                <ul>
                  <li>Family and medical history review</li>
                  <li>Explanation of testing options</li>
                  <li>Interpretation of results</li>
                  <li>Discussion of reproductive options</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Who benefits most</h2>
                <ul>
                  <li>Couples with a known family condition</li>
                  <li>Carriers of the same condition</li>
                  <li>People using donor eggs, sperm or a surrogate</li>
                  <li>Anyone with unclear results</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      What happens at a preconception genetic counseling
                      appointment?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        A counselor reviews your history, explains testing
                        options and results, and discusses next steps.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>When should I see a genetic counselor?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Before pregnancy is ideal, especially after a positive
                        carrier result or with a family history.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Is genetic counseling covered by insurance?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Often, when medically indicated. Check with your plan.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can I do genetic counseling online?</summary>
                    <div className="ffh-ans">
                      <p>Yes. Many counselors offer video visits.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Do both partners need to attend?</summary>
                    <div className="ffh-ans">
                      <p>It helps, but it isn&apos;t required.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Will the counselor tell me what to do?</summary>
                    <div className="ffh-ans">
                      <p>
                        No. Counselors explain options; decisions are yours.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/family-planning/carrier-screening">
                    Family Planning &amp; Carrier Screening →
                  </Link>
                  <Link to="/family-planning/what-is-carrier-screening">
                    What Is Carrier Screening? →
                  </Link>
                  <Link to="/family-planning/carrier-screening-cost">
                    Carrier Screening Cost →
                  </Link>
                  <Link to="/family-planning/carrier-screening-existing-results">
                    Existing Carrier Screening Results →
                  </Link>
                  <Link to="/family-planning/cystic-fibrosis-carrier-screening">
                    Cystic Fibrosis Carrier Screening →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What happens in a session</a>
                  </li>
                  <li>
                    <a href="#s2">Who benefits most</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
